/* global SideDrawer */

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    this.cartRefreshHandler = this.cartRefreshHandler.bind(this);
document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    this.addEventListener('on:cart-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
    this.addEventListener('on:cart:after-merge', () => {
  theme.manuallyLoadImages(this);
  this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
  enforceQuantityLimits(this);
});
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  /**
   * Trigger refresh of contents
   */
  cartRefreshHandler() {
    this.querySelector('cart-form').refresh();
  }

  /**
   * Update section's cart-form element with new contents
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
  this.querySelector('cart-form').refreshFromHtml(html);

  setTimeout(() => {
    enforceQuantityLimits(this);
  }, 100);
}
}
function enforceQuantityLimits(cartDrawer) {
  const MAX_QTY = 4;
  const LIMITED_VARIANT_IDS = ['42366565613677', '42366565646445'];

  const itemRows = cartDrawer.querySelectorAll('[data-merge-list-item]');
  itemRows.forEach((itemRow) => {
    const quantityInput = itemRow.querySelector('input[type="number"]');
    const plusButton = itemRow.querySelector('.quantity-up');
    const itemKeyAttr = quantityInput?.dataset?.key || '';
    const variantIdFromKey = itemKeyAttr.split(':')[0];

    const isRestricted = LIMITED_VARIANT_IDS.includes(variantIdFromKey);

    if (isRestricted && quantityInput && plusButton) {
      quantityInput.setAttribute('max', MAX_QTY);

      quantityInput.addEventListener('input', () => {
        let currentQty = parseInt(quantityInput.value);
        if (currentQty > MAX_QTY) {
          quantityInput.value = MAX_QTY;
          currentQty = MAX_QTY;
          alert(`You can only add up to ${MAX_QTY} of this product.`);
        }

        let existingNote = itemRow.querySelector('.max-qty-note');

        if (currentQty === MAX_QTY) {
          if (!existingNote) {
            const note = document.createElement('div');
            note.className = 'max-qty-note';
            note.style.fontSize = '12px';
            note.style.marginTop = '6px';
            note.style.color = '#a94442';
            note.textContent = `Note: Maximum ${MAX_QTY} per order.`;
            quantityInput.parentElement.appendChild(note);
          }
        } else {
          if (existingNote) {
            existingNote.remove();
          }
        }
      });

      // Initial state check (e.g. if cart is loaded with 4)
      const startingQty = parseInt(quantityInput.value);
      if (startingQty === MAX_QTY && !itemRow.querySelector('.max-qty-note')) {
        const note = document.createElement('div');
        note.className = 'max-qty-note';
        note.style.fontSize = '12px';
        note.style.marginTop = '6px';
        note.style.color = '#a94442';
        note.textContent = `Note: Maximum ${MAX_QTY} per order.`;
        quantityInput.parentElement.appendChild(note);
      }

      if (startingQty >= MAX_QTY) {
        plusButton.classList.add('unusable');
        plusButton.setAttribute('aria-disabled', 'true');
        plusButton.onclick = (e) => {
          e.preventDefault();
          alert(`You can only add up to ${MAX_QTY} of this product.`);
        };
      }
    }
  });
}
window.customElements.define('cart-drawer', CartDrawer);
